<template>
  <div id="editar-representante" class="ver-dica">
    <div class="position-relative" v-if="Fields.partner !== null">
      <h1 class="title text-uppercase font-weight-bold">Editar afiliado</h1>
      <!-- <b-badge
        v-if="Fields.partner.status === partnerState.NOT_EVALUATED"
        :variant="Fields.partner.status === partnerState.REPROVED ? 'danger' : 'success'"
      >
        {{
          Fields.partner.status === partnerState.REPROVED
          ? 'Reprovado'
          : 'Aprovado'
        }}
      </b-badge> -->
      <hr class="linha-amarela" />
      <div class="row">
        <div
          class="col-8 col-md-8 col-sm-12"
          v-if="Fields.partner.nome !== null"
        >
          <div class="form-group">
            <label for="editName">Nome</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.nome"
              id="editName"
              aria-describedby="Nome do Afiliado"
              :placeholder="Fields.partner.nome"
            />
          </div>
        </div>
        <div class="col-4" v-if="Fields.partner.cpf !== null">
          <div class="form-group">
            <label for="editCPF">CPF</label>
            <input
              type="text"
              class="form-control"
              v-mask="'###.###.###-##'"
              v-model="Fields.partner.cpf"
              id="editCPF"
              aria-describedby="CPF do Afiliado"
              :placeholder="Fields.partner.cpf"
            />
          </div>
        </div>
        <div class="col-4" v-if="Fields.partner.rg !== null">
          <div class="form-group">
            <label for="editRG">RG</label>
            <input
              type="text"
              class="form-control"
              v-mask="'##.###.###-#'"
              v-model="Fields.partner.rg"
              id="editRG"
              aria-describedby="RG do Afiliado"
              :placeholder="Fields.partner.rg"
            />
          </div>
        </div>
        <div class="col-4" v-if="Fields.partner.cnpj !== null">
          <div class="form-group">
            <label for="editCNPJ">CNJP</label>
            <input
              type="text"
              class="form-control"
              v-mask="'##.###.###/####-##'"
              v-model="Fields.partner.cnpj"
              id="editCNPJ"
              aria-describedby="CNPJ do Afiliado"
              :placeholder="Fields.partner.cnpj"
            />
          </div>
        </div>
        <div class="col-8" v-if="Fields.partner.endereco !== null">
          <div class="form-group">
            <label for="editAddress">Endereço</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.endereco"
              id="editAddress"
              aria-describedby="Endereço do Afiliado"
              :placeholder="Fields.partner.endereco"
            />
          </div>
        </div>
        <div class="col-4" v-if="Fields.partner.numero !== null">
          <div class="form-group">
            <label for="editNumber">Número</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.numero"
              id="editNumber"
              aria-describedby="Numero do Afiliado"
              :placeholder="Fields.partner.numero"
            />
          </div>
        </div>
        <div class="col-5" v-if="Fields.partner.complemento !== null">
          <div class="form-group">
            <label for="editComplement">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.complemento"
              id="editComplement"
              aria-describedby="Complemento do Afiliado"
              :placeholder="Fields.partner.complemento"
            />
          </div>
        </div>
        <div class="col-3" v-if="Fields.partner.cep !== null">
          <div class="form-group">
            <label for="editCEP">CEP</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.cep"
              id="editCEP"
              aria-describedby="CEP do Afiliado"
              :placeholder="Fields.partner.cep"
            />
          </div>
        </div>
        <div class="col-5" v-if="Fields.partner.bairro !== null">
          <div class="form-group">
            <label for="editNeighborhood">Bairro</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.bairro"
              id="editNeighborhood"
              aria-describedby="Bairro do Afiliado"
              :placeholder="Fields.partner.bairro"
            />
          </div>
        </div>
        <div class="col-3" v-if="Fields.partner.cidade !== null">
          <div class="form-group">
            <label for="editCity">Cidade</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.cidade"
              id="editCity"
              aria-describedby="Cidade do Afiliado"
              :placeholder="Fields.partner.cidade"
            />
          </div>
        </div>
        <div class="col-3" v-if="Fields.partner.estado !== null">
          <div class="form-group">
            <label for="editState">UF</label>
            <input
              type="text"
              class="form-control"
              v-model="Fields.partner.estado_id"
              id="editState"
              aria-describedby="Estado do Afiliado"
              :placeholder="Fields.partner.estado_id"
            />
          </div>
        </div>
        <div class="col-3" v-if="Fields.partner.celular !== null">
          <div class="form-group">
            <label for="editCellPhone">Celular / Whatsapp</label>
            <input
              type="text"
              class="form-control"
              v-mask="['(##) #####-####', '(##) ####-####']"
              v-model="Fields.contact.celular"
              id="editCellPhone"
              aria-describedby="Celular do Afiliado"
              :placeholder="Fields.contact.celular"
            />
          </div>
        </div>
        <div class="col-3" v-if="Fields.contact.telefone !== null">
          <div class="form-group">
            <label for="editTelephone">Telefone</label>
            <input
              type="text"
              class="form-control"
              v-mask="'(##) ####-####'"
              v-model="Fields.contact.telefone"
              id="editTelephone"
              aria-describedby="Telefone do Afiliado"
              :placeholder="Fields.contact.telefone"
            />
          </div>
        </div>
        <div class="col-3" v-if="Fields.contact.telefone2 !== null">
          <div class="form-group">
            <label for="editTelephon2">Telefone 2</label>
            <input
              type="text"
              class="form-control"
              v-mask="'(##) ####-####'"
              v-model="Fields.contact.telefone2"
              id="editTelephone2"
              aria-describedby="Telefone do Afiliado"
              :placeholder="Fields.contact.telefone2"
            />
          </div>
        </div>
        <div class="col-6" v-if="Fields.partner.cidades_atuacao !== null">
          <div class="form-group">
            <label for="editActingCity">Cidades de atuação</label>
            <v-select
              label="nome"
              id="editActingCity"
              v-model="Fields.partner.cidades_atuacao"
              :options="cidades"
              :reduce="(cidades) => cidades.id"
              placeholder="Escolha a cidade do afiliado"
              multiple
            >
              <div slot="no-options">Nenhuma cidade foi encontrada.</div>
            </v-select>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-6">
          <label for="editEmail">Email</label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.partner.email"
            id="editEmail"
            aria-describedby="Email do Parceiro"
            :placeholder="Fields.partner.email"
          />
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-6">
          <label for="editPassword">Senha</label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.partner.password"
            id="editPassword"
            aria-describedby="Senha do Parceiro"
            :placeholder="'******'"
          />
        </div>
      </div>
      <b-button class="btn btn-success ml-2" @click="save()">
        Atualizar Dados
      </b-button>
      <!-- <div class="form-group">
        <button class="btn btn-success ml-2 text-white">
          Atualizar
        </button>
        <b-button
          v-if="Fields.partner.status === partnerState.APPROVED"
          class="btn-danger ml-2"
          @click="$bvModal.show('reason')"
        >
          Rejeitar
        </b-button>
        <div class="form-fields" v-else>
          <h1 class="title text-uppercase">Esse representante não existe mais!</h1>
        </div>
      </div> -->
      <!-- <b-modal
        title="Motivo da rejeição"
        size="xl"
        id="reason"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
      >
        <div class="row container">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <b-form-textarea
                type="text"
                class="form-control"
                placeholder="Descreva os motivos pelos quais você está rejeitando esse afiliado"
                rows="4"
                max-rows="10"
                v-model="Fields.reason"
                @input="errorMessages.reason = null"
              ></b-form-textarea>
              <p
                class="error-message text-danger"
                v-if="errorMessages.reason !== null"
              >
                {{ errorMessages.reason }}
              </p>
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100">
            <button
              type="button"
              class="btn btn-danger float-right"
              @click="reject(getpartner.id)"
            >
              Rejeitar
              <i class="fas fa-handshake-slash ml-2"></i>
            </button>
          </div>
        </template>
      </b-modal> -->
      <button class="btn bg-orange ml-2 text-white" @click="backToList()">
        Voltar
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import makeToast from '../../../mixins/makeToast';
import UserState from '../../../enums/UserState';

export default {
  name: 'EditPartner',
  mixins: [makeToast],
  data() {
    return {
      UserState,
      Fields: {
        partner: {},
        contact: {},
        reason: null,
      },
      errorMessages: {
        reason: null,
      },
    };
  },
  props: ['id'],
  computed: {
    ...mapGetters('partner', ['getPartner']),
    ...mapState({
      estados: (state) => state.estados,
      cidades: (state) => state.cidades,
      segmentos: (state) => state.segmentos,
    }),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.getContact(this.getPartner.usuario_id).then((response) => {
      this.Fields.contact = response.data;
    });
    this.get(this.id).finally(() => this.$store.dispatch('endLoader'));

    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadSegmentos');
  },
  updated() {
    this.Fields.partner = this.getPartner;
  },
  methods: {
    ...mapActions('partner', ['get', 'getContact', 'updateData']),
    backToList() {
      this.$router.push({
        name: 'administrador-parceiros',
      });
    },
    save() {
      const data = {
        usuario_id: this.Fields.partner.usuario_id,
        parceiro_id: this.Fields.partner.id,
        rg: this.Fields.partner.rg,
        cpf: this.Fields.partner.cpf,
        cnpj: this.Fields.partner.cnpj,
        email: this.Fields.partner.email,
        password: this.Fields.partner.password,
        nome: this.Fields.partner.nome,
        endereco: this.Fields.partner.endereco,
        numero: this.Fields.partner.numero,
        complemento: this.Fields.partner.complemento,
        cep: this.Fields.partner.cep,
        bairro: this.Fields.partner.bairro,
        cidade_id: this.Fields.partner.cidade_id,
        estado_id: this.Fields.partner.uf,
        id_cidades_atuacao: this.Fields.partner.cidades_atuacao,
        celular: this.Fields.contact.celular,
        telefone: this.Fields.contact.telefone,
        telefone2: this.Fields.contact.telefone2,
      };

      this.updateData(data)
        .then(() => {
          this.makeToast('Sucesso!', 'Parceiro atualizado sucesso');
        })
        .catch((error) => {
          this.makeToast('Oopss!', error, 'danger');
        });
    },
  },
};
</script>
